'use client'
import { ExternalLink } from 'modules/components'
import {
  CompanyGroup,
  CopyrightGroup,
  FooterGroup,
  FooterLogo,
  FooterSocialGroup,
  ServiceGroup,
} from 'modules/constant'
import Link from 'next/link'
import { PropsWithChildren, ReactNode } from 'react'
import {
  TrackClick,
  TrackerProvider,
  TrackExposure,
  TrackPageSection,
  TrackPageType,
  TrackRoute,
} from 'modules/analysis'

function Title({ children }: PropsWithChildren) {
  return <span className="mb-9 text-2xl font-bold uppercase">{children}</span>
}

function GroupWrapper({ title, children }: PropsWithChildren<{ title: ReactNode }>) {
  return (
    <div className="flex-y-start">
      <Title>{title}</Title>
      <div className="flex-y-start gap-y-4 text-lg font-medium opacity-80">{children}</div>
    </div>
  )
}

function Group({ title, list }: FooterGroup) {
  return (
    <GroupWrapper title={title}>
      {list.map(({ path, content, tracker }) => (
        <TrackRoute config={tracker!} key={path}>
          <Link href={path} key={path} className="link">
            {content}
          </Link>
        </TrackRoute>
      ))}
    </GroupWrapper>
  )
}

function LayoutFooter() {
  return (
    <div className="bg-black-bg z-10 w-full shrink-0 py-20">
      <TrackerProvider config={{ pageType: TrackPageType.Footer }}>
        <TrackExposure config={{ sectionName: TrackPageSection }}>
          <div className="section-content">
            {FooterLogo}
            <div className="tezt-26px mt-10 flex flex-wrap items-start justify-between gap-10 font-bold">
              <Group {...ServiceGroup} />
              <Group {...CompanyGroup} />
              <GroupWrapper title={FooterSocialGroup.title}>
                <div className="flex gap-x-3">
                  {FooterSocialGroup.list.map(({ path, content, tracker }) => {
                    return (
                      <TrackClick config={tracker!} key={path}>
                        <ExternalLink key={path} href={path} className="link">
                          {content}
                        </ExternalLink>
                      </TrackClick>
                    )
                  })}
                </div>
              </GroupWrapper>
              <GroupWrapper title={CopyrightGroup.title}>
                <a>{CopyrightGroup.list[0].content}</a>
              </GroupWrapper>
            </div>
          </div>
        </TrackExposure>
      </TrackerProvider>
    </div>
  )
}

export default LayoutFooter
